import { api } from "./apiClient";

export const walkSchedulesAPI = {
  listByProject: (projectId) => api.get(`/projects/${projectId}/walk-schedules`),

  listCalendar: (projectId, start, end, scope = "mine") =>
    api.get(`/projects/${projectId}/walk-schedules/calendar`, {
      params: { start, end, scope },
    }),

  listTeamCalendar: (projectId, userId, start, end) =>
    api.get(`/projects/${projectId}/walk-schedules/team-calendar`, {
      params: { user_id: userId, start, end },
    }),

  create: (projectId, payload) =>
    api.post(`/projects/${projectId}/walk-schedules`, payload),

  update: (projectId, scheduleId, payload) =>
    api.patch(`/projects/${projectId}/walk-schedules/${scheduleId}`, payload),

  updateStatus: (projectId, scheduleId, payload) =>
    api.patch(`/projects/${projectId}/walk-schedules/${scheduleId}/status`, payload),

  checkAvailability: (projectId, payload) =>
    api.post(`/projects/${projectId}/walk-schedules/availability`, payload),

  createBusyPeriod: (projectId, payload) =>
    api.post(`/projects/${projectId}/walk-schedules/busy-periods`, payload),

  updateBusyPeriod: (projectId, busyPeriodId, payload) =>
    api.patch(
      `/projects/${projectId}/walk-schedules/busy-periods/${busyPeriodId}`,
      payload,
    ),

  deleteBusyPeriod: (projectId, busyPeriodId) =>
    api.delete(
      `/projects/${projectId}/walk-schedules/busy-periods/${busyPeriodId}`,
    ),

  getAttentionItems: (projectId, limit = 5) =>
    api.get(`/projects/${projectId}/attention-items`, { params: { limit } }),

  markNotificationRead: (notificationId) =>
    api.patch(`/notifications/${notificationId}/read`),
};
